// Announcement bar dismiss with localStorage persistence
(function () {
  const bar = document.getElementById('header-announcement');
  const closeBtn = document.getElementById('announcement-close');
  const STORAGE_KEY = 'orchids_announcement_dismissed';

  if (!bar) return;

  if (localStorage.getItem(STORAGE_KEY) === 'true') {
    bar.style.display = 'none';
    return;
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      bar.style.display = 'none';
      localStorage.setItem(STORAGE_KEY, 'true');
    });
  }
})();

// Sticky sub-menu — fires after full page load to get correct offset
(function () {
  window.addEventListener('load', function () {
    const subMenu = document.querySelector('.header-sub-menu');
    if (!subMenu) return;

    let isStuck = false;
    let placeholder = null;
    const subMenuTop = subMenu.getBoundingClientRect().top + window.scrollY;
    const subMenuHeight = subMenu.offsetHeight;

    window.addEventListener('scroll', function () {
      if (window.scrollY > subMenuTop && !isStuck) {
        placeholder = document.createElement('div');
        placeholder.style.height = subMenuHeight + 'px';
        subMenu.parentNode.insertBefore(placeholder, subMenu);

        subMenu.style.position = 'fixed';
        subMenu.style.top = '0';
        subMenu.style.left = '0';
        subMenu.style.right = '0';
        subMenu.style.width = '100%';
        subMenu.style.zIndex = '9999';
        isStuck = true;

      } else if (window.scrollY <= subMenuTop && isStuck) {
        subMenu.style.position = '';
        subMenu.style.top = '';
        subMenu.style.left = '';
        subMenu.style.right = '';
        subMenu.style.width = '';
        subMenu.style.zIndex = '';
        if (placeholder) {
          placeholder.parentNode.removeChild(placeholder);
          placeholder = null;
        }
        isStuck = false;
      }
    });
  });
})();
